import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { MOBILE_BREAKPOINT } from "@ryde/theme";

export const TabEarContainerStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "tab-ears-container",
})`
  padding-inline-start: 24px;
  width: 100%;

  transition:
    filter 0.55s ease-out,
    backdrop-filter 0.55s ease-out;
  &.inner-item-editing {
    filter: blur(2px) grayscale(100%);
    backdrop-filter: blur(3px);
    pointer-events: none;
  }

  .MuiTabs-scrollButtons.Mui-disabled {
    opacity: 0.3;
  }
`;
export const TabPanelStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "tab-panel",
})`
  width: 100%;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding-inline-end: 10px;
  }
`;
